<template>
  <div class="fields" v-if="fields.length">
    <div class="field" v-for="field in fields" :key="field.id">
      <span>{{ field.boardField.description }}</span>
      <span>&nbsp;{{ field.total }}</span>
      <span v-if="field.boardField.suffix">&nbsp;{{ field.boardField.suffix }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ListFields",
  props: { list: { required: true } },
  computed: {
    ...mapState("boards", { activeBoard: "active" }),
    fields() {
      const fields = [];

      this.activeBoard.fields
        .filter(bf => bf.show_total)
        .forEach(bf => {
          const field = {
            boardField: bf,
            total: 0
          };

          this.list.cards.forEach(c => {
            const cardField = c.fields.find(cf => cf.boardField == bf);
            if (cardField) {
              field.total += cardField.value || 0;
            }
          });

          fields.push(field);
        });

      return fields;
    }
  }
};
</script>

<style scoped>
.fields {
  margin: 0 0 10px;
  font-size: 14px;
  color: #888;
  padding: 5px;
  border-bottom: 1px dashed #ddd;
  text-overflow: ellipsis;
  user-select: none;
  font-weight: bold;
}

.field {
}
</style>
